// extracted by css-extract-rspack-plugin
export default {"cls1":"HeroWorkCardHeader-cls1_Pwe","cls2":"HeroWorkCardHeader-cls2_r7k HeroWorkCardHeader-cls1_Pwe"};